import { render, staticRenderFns } from "./ButtonYahoo.vue?vue&type=template&id=4a1a4635&scoped=true&lang=pug&"
import script from "./ButtonYahoo.vue?vue&type=script&lang=js&"
export * from "./ButtonYahoo.vue?vue&type=script&lang=js&"
import style0 from "./ButtonYahoo.vue?vue&type=style&index=0&id=4a1a4635&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a4635",
  null
  
)

export default component.exports